var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-facebook';
                    var viewUrl = 'sprite.svg#view-icon-facebook';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 28 28',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };